import Icon from '../components/Icon.vue'

Icon.register({
  comments: {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M416 192c0 88.4-93.1 160-208 160-41 0-79.1-9.3-111.3-25-21.8 12.7-52.1 25-88.7 25-3.2 0-6-1.8-7.3-4.8s-0.7-6.4 1.5-8.7c0.3-0.3 22.4-24.3 35.8-54.5-23.9-26.1-38-57.7-38-92 0-88.4 93.1-160 208-160s208 71.6 208 160zM538 412c13.4 30.3 35.5 54.2 35.8 54.5 2.2 2.4 2.8 5.8 1.5 8.7-1.2 2.9-4.1 4.8-7.3 4.8-36.6 0-66.9-12.3-88.7-25-32.2 15.8-70.3 25-111.3 25-86.2 0-160.2-40.4-191.7-97.9 10.4 1.1 20.9 1.9 31.7 1.9 132.3 0 240-86.1 240-192 0-6.8-0.4-13.5-1.3-20.1 75.8 23.9 129.3 81.2 129.3 148.1 0 34.3-14.1 66-38 92z'
      }
    ]
  }
})
